import { Colors } from "@template/style";

const LabelRequired = ({ title }: { title?: React.ReactNode }) => {
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <span>{title}</span>
      <span
        style={{
          color: Colors.REQUIRE,
          fontWeight: "900",
          fontSize: 18,
          paddingLeft: 5,
        }}
        className="IgnoreExtractRuleTarget"
      >
        {"＊"}
      </span>
    </span>
  );
};

export default LabelRequired;
